import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

const createStorage = createStorageCategory('session', 'SETUP')

export const savedConnectUrl = createStorage('connect_url', v.string())
export const savedRegion = createStorage('region', v.string())
export const savedAccountId = createStorage('accountId', v.string())
export const savedInstanceId = createStorage('instanceId', v.string())
export const savedArn = createStorage('arn', v.string())
export const savedSetupAccessKey = createStorage('setupAccessKey', v.string())

// prettier-ignore
export const savedSetupAccessSecret = createStorage('setupAccessSecret',v.string())
export const savedUserGroup = createStorage('userGroup', v.string())
export const savedSetupUser = createStorage('setupUser', v.string())
export const savedPolicyName = createStorage('policyName', v.string())
export const savedAccessKey = createStorage('accessKey', v.string())
export const savedAccessSecret = createStorage('accessSecret', v.string())
